// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ccrabuviprruixmbrsta.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNjcmFidXZpcHJydWl4bWJyc3RhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDU5NzQ0OTEsImV4cCI6MjA2MTU1MDQ5MX0.Ys0P1WqLph9zXlBSie1xEYqFHCILelAowcCBabj7Nn0";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);